<template>
   <TutorProfile :profileDetails="profileDetails" :enrolledStudents="enrolledStudents"
      :previousEnrolledStudents="previousEnrolledStudents" :feedbacks="feedbacks"
      :reviewsPagination="reviewsPagination" @change-review-page="$emit('change-review-page', $event)"/>
</template>
<script setup>
import TutorProfile from "@/views/adminPublicProfile/tutorProfile.vue";
import { defineProps, defineEmits } from "vue";
defineProps({
   profileDetails: null,
   enrolledStudents: null,
   previousEnrolledStudents: null,
   feedbacks:null,
   reviewsPagination: null
})
defineEmits(['change-review-page'])
</script>
<style scoped>

</style>